import React from 'react';
import { LzPLayoutBase } from './type';
import LzSApp from '@lz/app/App';
import LzXDimmer from '../../commons/Dimmer';
import LzXNotificationsContainer from '../../commons/Notifications';
import lzSCommonsLoadingAtom from '@lz-atoms/Commons/loading';

import './styles.scss';
import { useAtomValue } from 'jotai';

export default function LzXLayoutBase(props: LzPLayoutBase) {
  const commonsLoadingState = useAtomValue(lzSCommonsLoadingAtom);

  return (
    <React.Fragment>
      <div
        className={
          'lz-layout-base lz-hide-bg-on-print ' + (props.className || '')
        }
        style={{
          backgroundImage: `url(${props.bgImg || LzSApp.base_bg_image
            })`,
          ...(props.style || {}),
        }}
      >
        <div className='lz-layout-base-inner'>
          <div style={{ minHeight: '100%' }}>{props.children}</div>
        </div>
      </div>

      <LzXDimmer active={commonsLoadingState} />

      <LzXNotificationsContainer />
    </React.Fragment>
  );
}
